export default __webpack_public_path__ + "static/media/personalDetailshelpHighlight@2x.2cc09af9.png";